import { render, staticRenderFns } from "./QingKe.vue?vue&type=template&id=2f4d3a84&scoped=true&"
import script from "./QingKe.vue?vue&type=script&lang=js&"
export * from "./QingKe.vue?vue&type=script&lang=js&"
import style0 from "./QingKe.vue?vue&type=style&index=0&id=2f4d3a84&scoped=true&lang=css&"
import style1 from "./QingKe.vue?vue&type=style&index=1&id=2f4d3a84&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4d3a84",
  null
  
)

export default component.exports